import React from 'react';
import { Group } from '@mantine/core';
import { PairDeviceButton } from './PairDeviceButton';
import { UnpairDeviceButton } from './UnpairDeviceButton';
import { Device } from '@types';

export interface DevicePairingActionsButtonGroupProps {
  device: Device;
  isPaired: boolean;
  onPair: (device: Device) => void;
  onUnpair: (deviceId: string) => Promise<void>;
  onSuccess?: () => void;
  onError?: (error: Error) => void;
  showPairButton?: boolean;
  showUnpairButton?: boolean;
  pairDisabled?: boolean;
}

export const DevicePairingActionsButtonGroup: React.FC<
  DevicePairingActionsButtonGroupProps
> = ({
  device,
  isPaired,
  onPair,
  onUnpair,
  onSuccess,
  onError,
  showPairButton = true,
  showUnpairButton = true,
  pairDisabled = false,
}) => {
  return (
    <Group gap='xs'>
      {!isPaired && showPairButton && (
        <PairDeviceButton
          device={device}
          onPair={onPair}
          onSuccess={onSuccess}
          onError={onError}
          size='xs'
          disabled={pairDisabled}
          tooltip={
            pairDisabled
              ? 'Hai già un sensore accoppiato. Disaccoppialo prima di abbinarne un altro.'
              : 'Abbina il sensore ad un dispositivo'
          }
        />
      )}

      {isPaired && showUnpairButton && (
        <UnpairDeviceButton
          deviceId={device.id.toString()}
          deviceName={device.name || device.model}
          onUnpair={onUnpair}
          onSuccess={onSuccess}
          onError={onError}
          size='xs'
        />
      )}
    </Group>
  );
};
